export class Teleconsultation {
	isTeleconsultation: boolean;

	constructor(
		isTeleconsultation: boolean = false
	) {
		this.isTeleconsultation = isTeleconsultation;
	}
}

export interface TeleconsultationState {
	teleconsultation?: Teleconsultation;
}
